import { Injectable } from '@angular/core';
import { catchError, Observable, of, tap, throwError } from 'rxjs';
import { ApiConstants } from '../../../shared/constants/api-constants';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ChangeControlActionPlan } from '../models/change-control-action-plan';
import { ExtendedActionItem } from '../models/extend-action-item';
import { SharedConstants } from '../../../../app/shared/constants/shared-constants';

@Injectable({
  providedIn: 'root'
})
export class ActionPlanService {
  typesList: any[] = [];
  usersList: any = [];

  constructor(private httpClient: HttpClient) { }

  getTypes(): Observable<any> {
    let observable: Observable<any>;
    if (this.typesList.length > 0) {
      observable = of(this.typesList);
    }
    else {
      observable = this.httpClient.get<any>(ApiConstants.ActionItem_GetTypes_Api)
        .pipe(
          tap(typesData => this.typesList = typesData)
        );
    }
    return observable;
  }

  getUsersLookUpData(scopes: any, scopeChange: boolean): Observable<any> {
    const requestPayload = { scopes: scopes };
    let observable: Observable<any>;
    // If there is a scope change, we need to get updated userList
    if(scopeChange){
      this.usersList = [];
      observable = this.httpClient.get<any>(ApiConstants.ActionItem_GetUserLookUp_Api, {params : requestPayload})
          .pipe(
            tap(usersData => this.usersList = usersData)
          );
    }
    else{
      if (this.usersList.length > 0) {
        observable = of(this.usersList);
      }
      else {
        observable = this.httpClient.get<any>(ApiConstants.ActionItem_GetUserLookUp_Api, {params : requestPayload})
          .pipe(
            tap(usersData => this.usersList = usersData)
          );
      }
    }
    return observable;
  }

uploadFile(file: File, foldername: string): Observable<any> {
  const formData = new FormData();
  formData.append(file.name, file);
  return this.httpClient.post(
    ApiConstants.Files_Upload_Api + foldername, formData
  ).pipe(
    catchError((error: any) => {
      let errorMessage = SharedConstants.File_Upload_Failed_Error;
      
      if (error.status === 400 && error?.error.errorMessage) {
        // Handle duplicate file error or validation errors
        errorMessage = error.error.errorMessage;
      } else if (error.status === 401) {
        errorMessage = SharedConstants.UnAuthorized_File_Upload_Error;
      } else if (error.status === 500 && error?.error.errorMessage) {
        errorMessage = error.error.errorMessage;
      }
      
      return throwError(() => errorMessage);
    })
  );
}

  saveActionPlan(actionPlan: ChangeControlActionPlan): Observable<any> {
    return this.httpClient.post(
      ApiConstants.ActionItem_SaveActionPlanApi,
      actionPlan
    );
  }

  getCreatedActionPlanAndActionItems(actionPlanId: string, actionItemIds: string[]): Observable<any> {
    return this.httpClient.post(
      ApiConstants.ActionItem_GetCreatedActionPlanAndActionItems.replace('{actionPlanId}', actionPlanId),
      actionItemIds
    );
  }

  getActionPlanForCC(CCNumber: string) : Observable<any>{
    return this.httpClient.get(ApiConstants.ActionItem_GetActionItems + '/' + `${CCNumber}`);
  }

  // download attachment from Action Item
  downloadFile(fileId: string) : Observable<any> {
    return this.httpClient.get(ApiConstants.Files_Download_Api + `${fileId}`);
  }

  deleteFile(fileId: string): Observable<any> {
    return this.httpClient.delete<any>(
      `${ApiConstants.Files_Delete_Api}${fileId}`
    );
  }

  updateActionItem(extendActionItem: ExtendedActionItem) : Observable<any>{
    return this.httpClient.put(ApiConstants.ActionItem_UpdateActionItem, extendActionItem);
  }


}
